const _ = require('lodash');
import AOS from 'aos';

AOS.init({
    once: true,
})


if( document.readyState !== 'loading' ) {
    document.body.classList.remove('preload');
} else {
    document.addEventListener('DOMContentLoaded', function () {
        document.body.classList.remove('preload');
    });
}

//
// Desktop and Mobile Main navigation code
//
import DesktopNav from './molecules/desktop-menu';
import MobileNav from './molecules/mobile-menu';

document.addEventListener('DOMContentLoaded', function () {
    // Initialize Modules
    new DesktopNav();
    new MobileNav();
});

const form = document.querySelector('[data-validate]');

/**
* title First Tab
* description Add class to body if the user is a keyboard user
**/
function firstTab(e) {

    if (e.keyCode === 9) { // Tab key
        document.documentElement.classList.add('user-is-tabbing');
        window.removeEventListener('keydown', firstTab);
	}
}

window.addEventListener('keydown', firstTab);

/** Header Scroll **/

import './organisms/header-scroll';

/** Atoms **/
import "./atoms/file"

/** Modules **/

/*** Lazy Load ***/
import lazy from "./modules/lazy-load"

if( document.readyState !== 'loading' ) {
    lazy.init();

} else {
    document.addEventListener('DOMContentLoaded', function () {
        lazy.init();
    });
}

/** Cookies **/
import initCookie from './modules/cookie-notice.js';

const observer = new MutationObserver(function(mutations) {
    const targetNode = document.getElementById('hs-eu-confirmation-button');
    if (targetNode) {
        initCookie();
        observer.disconnect(); // We can disconnect observer once the element exist if we don't want observe more changes in the DOM
        return;
    }
});

// Start observing
observer.observe(document.body, { // document.body is node target to observe
    childList: true, // This is a must have for the observer with subtree
    subtree: true // Set to true if changes must also be observed in descendants.
});

/** Accessibility **/
import accessibilityJS from "./modules/accessibility"
accessibilityJS();

/** Atoms **/

/*** Scroll to Top ***/
import scrollToTop from "./atoms/scroll-to-top"
scrollToTop();

/*** Videos ***/
import videos from "./atoms/video"
videos();

/*** Modal ***/
import modal from "./atoms/modal"
modal();

/*** Show/Hide ***/
import showHide from "./atoms/show-hide"
showHide();

/**
* title Dropdowns
* description Create manual dropdowns if a select isn't viable
*/

function customDropdown() {
    const dropdownParent = document.querySelector('[data-dropdown-parent]');
    if (document.body.contains(dropdownParent)) {
        const dropdownParent = document.querySelectorAll('[data-dropdown-parent]');
        for (let i = 0; i < dropdownParent.length; i++) {
            const dropdownChild = dropdownParent[i].querySelectorAll('[data-dropdown-button]');
            const dropdown = dropdownParent[i].querySelector('[data-dropdown]');
            for (let i = 0; i < dropdownChild.length; i++) {
                dropdownChild[i].addEventListener('click', function(e) {
                    dropdown.classList.toggle('active');
                    dropdown.parentNode.toggleAttribute('data-dropdown-open');
                });
            }
        }
    }
};

customDropdown();

/**
* title Video placeholder
* description Click video placeholder to display video
**/

const videoBlock = document.querySelector('[data-video-container]');
if (document.body.contains(videoBlock)) {
    const videoBlocks = document.querySelectorAll('[data-video-container]');
    for (let i = 0; i < videoBlocks.length; i++) {
        const videoPlaceholder = videoBlocks[i].querySelector('[data-video-placeholder]');
        videoPlaceholder.addEventListener('click', function(){
            const videoContainer = videoBlocks[i].querySelector('[data-video-iframe]');
            const videoIframe = videoContainer.querySelector('iframe');
            videoPlaceholder.classList.add('d-none');
            videoContainer.classList.remove('d-none');

            const videoSrc = videoIframe.src.split('?');

            videoIframe.src = videoSrc[0] + "?autoplay=1&" + videoSrc[1];

        });
    }
}

/** Molecules **/

/*** Desktop Search ***/

import "./molecules/search"

/*** Accordion ***/
import "./molecules/accordion"

/** Organisms **/

// Quiz
import quiz from "./organisms/quiz"
quiz();

// Background Scroll
import "./organisms/background-scroll"
